export enum HomeSwitchCases {
  pretest = 'pretest',
  test = 'test',
}
